import { useTranslation } from 'react-i18next';
import CustomSelect from '../../../Forms/Element/CustomSelect';
import MovementType from './CashStatusType';
import CashStatusType from './CashStatusType';

/**
 * Componente responsável por listar os tipos de movimentações.
 */
const CashStatusSelect = (props) => {
  
  const { t } = useTranslation();
  const { value, onChange, error } = props;
  const options = [
    { value: CashStatusType.OPENED, label: t('opened') },
    { value: CashStatusType.CLOSED, label: t('closed') }
];

  return (
    <CustomSelect options={options} value={value} onChange={onChange} isClearable placeholder={t("select")} error={error}/>
  )
}

export default CashStatusSelect;